<template>
  <div>
    <div class="banner">
      <div class="headerReplacementFinancialInfo"></div>
      <div class="banner-text">
        <b>ข้อมูลสำคัญทางการเงิน</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลทางการเงิน</span>
          <span class="separator"></span>
          <span><b>ข้อมูลสำคัญทางการเงิน</b></span>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="TabMenu">
        <FinancialInfoTabMenu />
      </div>
      <div class="row justify-content-center">
        <div ref="chartContainer" class="mt-5" style="width: 90%; height: 400px;"></div>
      </div>

      <div class="mt-5 mb-3">หน่วย: บาท</div>
      <div class="table-responsive">
        <table class="table mb-5">
          <thead>
            <tr class="table-dark text-end">
              <th scope="col"></th>
              <th scope="col">2564</th>
              <th scope="col">2565</th>
              <th scope="col">2566</th>
            </tr>
          </thead>
          <thead>
            <tr class="table-secondary">
              <th scope="col-auto"><b>ข้อมูลสำคัญทางการเงิน</b></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">สินทรัพย์รวม</th>
              <td>{{ financialData[0]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[0]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">หนี้สินรวม</th>
              <td>{{ financialData[1]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[1]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">ส่วนของผู้ถือหุ้น (รวม)</th>
              <td>{{ financialData?.[2]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[2]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">รายได้จากการขาย</th>
              <td>{{ financialData?.[3]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[3]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">รายได้รวม</th>
              <td>{{ financialData?.[4]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[4]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">ต้นทุนขาย</th>
              <td>{{ financialData?.[5]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[5]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">ค่าใช้จ่ายรวม</th>
              <td>{{ financialData?.[6]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[6]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">กำไร/(ขาดทุน) สุทธิ (ส่วนที่เป็นของผู้ถือหุ้นของบริษัทฯ)</th>
              <td>{{ financialData?.[7]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialData?.[7]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData?.[7]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr class="table-secondary">
              <th scope="row"><b>อัตราส่วนทางการเงินที่สำคัญ</b></th>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row">อัตราผลตอบแทนผู้ถือหุ้น (ร้อยละ)</th>
              <td>{{ financialRatios?.[0]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[0]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตราผลตอบแทนจากสินทรัพย์ (ร้อยละ)</th>
              <td>{{ financialRatios?.[1]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[1]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตรากำไรขั้นต้น (ร้อยละ)</th>
              <td>{{ financialRatios?.[2]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[2]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตรากำไรสุทธิ (ร้อยละ)</th>
              <td>{{ financialRatios?.[3]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[3]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตราส่วนหนี้สินต่อส่วนของผู้ถือหุ้น D/E (เท่า)</th>
              <td>{{ financialRatios?.[4]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[4]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตราส่วนหนี้สินที่มีภาระดอกเบี้ยต่อส่วนของผู้ถือหุ้น IBD/E (เท่า)</th>
              <td>{{ financialRatios?.[5]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[5]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">อัตราหมุนเวียนของสินทรัพย์รวม (เท่า)</th>
              <td>{{ financialRatios?.[6]?.year_2564 || 'N/A' }}</td>
              <td>{{ financialRatios?.[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios?.[6]?.year_2566 || 'N/A' }}</td>
            </tr>


            <tr class="table-secondary">
              <th scope="row"><b>ข้อมูลสถิติ</b></th>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row">จำนวนหุ้นจดทะเบียน (หุ้น)</th>
              <td>{{ statisticalInformation?.[0]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[0]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">ราคา Par (บาท)</th>
              <td>{{ statisticalInformation?.[1]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[1]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">มูลค่าหลักทรัพย์ตามราคาตลาด (บาท)</th>
              <td>{{ statisticalInformation?.[2]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[2]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">Book Value per Share (บาท/หุ้น)</th>
              <td>{{ statisticalInformation?.[3]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[3]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">EPS (บาท/หุ้น)</th>
              <td>{{ statisticalInformation?.[4]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[4]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">P/E (เท่า)</th>
              <td>{{ statisticalInformation?.[5]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[5]?.year_2566 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">P/BV (เท่า)</th>
              <td>{{ statisticalInformation?.[6]?.year_2564 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation?.[6]?.year_2566 || 'N/A' }}</td>
            </tr>
            <!-- Add more rows as needed -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import FinancialInfoTabMenu from '@/components/FinancialInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";

export default {
  name: 'Info',
  components: {
    FinancialInfoTabMenu,
  },
  data() {
    return {
      financialData: [
        { year_2564: "35,398,442,918.92", year_2565: "48,091,145,335.00", year_2566: "65,230,434,459.00" }, // สินทรัพย์รวม
        { year_2564: "19,458,443,285.79", year_2565: "28,157,820,722.00", year_2566: "44,132,569,274.00" }, // หนี้สินรวม
        { year_2564: "15,939,999,633.20", year_2565: "19,933,324,613.00", year_2566: "21,097,865,185.00" }, // ส่วนของผู้ถือหุ้น (รวม)
        { year_2564: "13,623,385,589.08", year_2565: "11,676,439,515.00	", year_2566: "8,840,414,732.00" },  // รายได้จากการขาย
        { year_2564: "15,901,303,092.46	", year_2565: "16,157,150,694.00", year_2566: "15,187,019,209.00" }, // รายได้รวม
        { year_2564: "9,018,394,266.96", year_2565: "7,603,945,237.00	", year_2566: "6,211,580,848.00" },    // ต้นทุนขาย
        { year_2564: "2,344,089,739.42", year_2565: "2,431,321,848.00", year_2566: "3,307,629,721.00" },    // ค่าใช้จ่ายรวม
        { year_2564: "3,193,934,937.34", year_2565: "3,774,536,467.00", year_2566: "2,718,233,321.00" },    // กำไรสุทธิ
      ],

      financialRatios: [
        { year_2564: "24.28%", year_2565: "22.83%", year_2566: "14.62%" }, // อัตราผลตอบแทนผู้ถือหุ้น (ร้อยละ)	
        { year_2564: "13.14%", year_2565: "13.29%", year_2566: "7.81%" },  // อัตราผลตอบแทนจากสินทรัพย์ (ร้อยละ)	
        { year_2564: "33.80%", year_2565: "34.88%", year_2566: "29.74%" }, // อัตรากำไรขั้นต้น (ร้อยละ)	
        { year_2564: "20.03%", year_2565: "23.98%", year_2566: "17.93%" }, // อัตรากำไรสุทธิ (ร้อยละ)		
        { year_2564: "1.22", year_2565: "1.41", year_2566: "2.08" }, // อัตราส่วนหนี้สินต่อส่วนของผู้ถือหุ้น D/E (เท่า)	
        { year_2564: "0.97", year_2565: "1.11", year_2566: "1.62" }, // อัตราส่วนหนี้สินที่มีภาระดอกเบี้ยต่อส่วนของผู้ถือหุ้น IBD/E (เท่า)	
        { year_2564: "0.44", year_2565: "0.39", year_2566: "0.30" }, // อัตราหมุนเวียนของสินทรัพย์รวม (เท่า)				
      ],
      statisticalInformation: [
        { year_2564: "2,452,862,453", year_2565: "2,454,122,453", year_2566: "2,454,122,453" }, // จำนวนหุ้นจดทะเบียน (หุ้น)	
        { year_2564: "0.50", year_2565: "0.50", year_2566: "0.50" }, // ราคา Par (บาท)			
        { year_2564: "27,717,345,718.90", year_2565: "29,694,880,000.00", year_2566: "20,737,330,000.00" }, // มูลค่าหลักทรัพย์ตามราคาตลาด (บาท)	
        { year_2564: "6.50", year_2565: "6.64", year_2566: "7.75" }, // Book Value per Share (บาท/หุ้น)	
        { year_2564: "1.30", year_2565: "1.54", year_2566: "1.11" }, // EPS (บาท/หุ้น)			
        { year_2564: "9.15", year_2565: "5.60", year_2566: "6.37" }, // P/E (เท่า)			
        { year_2564: "1.86", year_2565: "1.09", year_2566: "0.91" }, // P/BV (เท่า)		
      ],
    };
  },
  methods: {
  },
  async mounted() {
    const convertToMillionBaht = (num) => {
      if (!num) return 0;
      const value = parseFloat(num.replace(/,/g, ''));
      return Math.round(value / 1000000);
    };

    this.total_income = [
      convertToMillionBaht(this.financialData[4]?.year_2564),
      convertToMillionBaht(this.financialData[4]?.year_2565),
      convertToMillionBaht(this.financialData[4]?.year_2566)
    ];

    this.net_profit = [
      convertToMillionBaht(this.financialData[7]?.year_2564),
      convertToMillionBaht(this.financialData[7]?.year_2565),
      convertToMillionBaht(this.financialData[7]?.year_2566)
    ];


    Highcharts.chart(this.$refs.chartContainer, {
      chart: {
        type: 'column',
        backgroundColor: '#F2F2F2',
      },
      title: {
        text: '',

      },
      xAxis: {
        categories: ['2564', '2565', '2566'],
        labels: {
          style: {
            fontFamily: 'Prompt, sans-serif',
          },
        },
      },
      yAxis: {
        title: {
          text: '',
        },
        labels: {
          enabled: false,
          style: {
            fontFamily: 'Prompt, sans-serif',
          },
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0, ',', ',');
          },
        },
        lineWidth: 0,
        gridLineWidth: 0,
      },
      tooltip: {
        formatter: function () {
          return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
        },
      },
      series: [
        {
          name: 'รายได้รวม',
          data: this.total_income,
          color: '#414042',
          dataLabels: {
            enabled: true,
            style: {
              fontFamily: 'Prompt, sans-serif',  // Data label font family
            },
            formatter: function () {
              return Highcharts.numberFormat(this.y, 0, ',', ',');
            },
          },
        },
        {
          name: 'กำไรสุทธิ',
          data: this.net_profit,
          color: '#E87D2E',
          dataLabels: {
            enabled: true,
            style: {
              fontFamily: 'Prompt, sans-serif',  // Data label font family
            },
            formatter: function () {
              return Highcharts.numberFormat(this.y, 0, ',', ',');
            },
          },
        },
      ],
      credits: {
        enabled: false,
      },
    });

  }

};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}

.table td {
  font-size: 0.85rem;
  font-weight: normal;
  padding: 8px;
  text-align: end;
}


</style>
